export default "__VITE_ASSET__A7Y4QFbe__"